import { api } from './axios'
import type { GenerateAESKeyResponseDto, GenerateKeyRequestDto } from './types'

/**
 * Generate entropy
 * Generates cryptographically secure random entropy data for use in security applications such as key generation, nonces, and initialization vectors.
 */
export const generateEntropy = async (): Promise<{ data: string }> => {
  const response = await api.post<{ data: string }>('/security/entropy')

  return response.data
}

/**
 * Generate noise
 * Generates pseudo-random noise data for testing, obfuscation, or statistical purposes. This is different from entropy as it may not be cryptographically secure.
 */
export const generateNoise = async (): Promise<{ data: string }> => {
  const response = await api.post<{ data: string }>('/security/noise')

  return response.data
}

/**
 * Generate keypair
 * Generates cryptographic keys based on keyType. RSA-4096 initiates async generation via Lambda (WebSocket delivery). AES-256 returns key immediately.
 */
export const generateKeypair = async (
  data: GenerateKeyRequestDto,
): Promise<GenerateAESKeyResponseDto | { [key: string]: never }> => {
  const response = await api.post<GenerateAESKeyResponseDto | { [key: string]: never }>(
    '/security/keypair',
    data,
  )

  return response.data
}
